/* eslint-disable camelcase */
import request from '@/api/config.js'

// Добавление нового автомобиля
export function createCar(data) {
  return request({
    url: `car/create`,
    method: 'post',
    data,
  })
}

// Получение всех автомобилей
export function getCars() {
  return request({
    url: `car`,
    method: 'get',
  })
}

// Получение всех типов автомобилей
export function getCarType() {
  return request({
    url: `car/car-type`,
    method: 'get',
  })
}
// Получение автомобиля по ID
export function getCarById(id) {
  return request({
    url: `car/${id}`,
    method: 'get',
  })
}

// Обновление данных об автомобиле
export function updateCar(id, data) {
  return request({
    url: `car/${id}`,
    method: 'put',
    data,
  })
}

// Удаление автомобиля по ID
export function deleteCar(id) {
  return request({
    url: `car/${id}`,
    method: 'delete',
  })
}
